import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { baseWebFetchOptions } from "./options";

export interface PostTechnicalTrainingParams {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  body?: string;
  recipient: string;
  subject: string;
  locale: string;
  technicalTrainingId: string;
}

export const postTechnicalTraining = (
  core: XcoreCore,
  { locale, technicalTrainingId, ...params }: PostTechnicalTrainingParams
): BaseApiRequest<Response> =>
  core.fetch(`/api/training/${technicalTrainingId}${parseQueryParamsObject({ locale })}`, {
    ...baseWebFetchOptions,
    method: "POST",
    body: JSON.stringify(params),
  });
